import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { useTranslation } from "react-i18next"
import {
  enableJobApplication,
  getJobApplicationTimeline,
  verifyActionOtp,
  withdrawnJobApplication,
} from "store/actions/jobApplicationAction"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { InputOtp } from "primereact/inputotp"
import { convertArabicToNumber } from "components/Common/Utils"

const Timeline = () => {
  const { t } = useTranslation()

  document.title = t("Timeline | Yamama")
  const dispatch = useDispatch()
  const {
    loading,
    isLoading,
    timeLine,
    enabled_withdrawn_action,
    enabled_application_action,
  } = useSelector(state => state.JobApplication)
  const [sessionId, setSessionId] = useState(null)
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [otp, setOtp] = useState("")
  const [applicationType, setApplicationType] = useState(null)

  const toggle = () => {
    if (modal) {
      setOtp("")
    }
    setModal(!modal)
  }
  const toggle1 = () => {
    if (modal1) {
    }
    setModal1(!modal1)
  }
  useEffect(() => {
    fetchTimelineData()
  }, [])

  const fetchTimelineData = () => {
    dispatch(getJobApplicationTimeline())
  }

  const handleWithdrawnJobApplication = () => {
    dispatch(withdrawnJobApplication())
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          const { sessionId } = data
          setSessionId(sessionId)
          dispatch(showAlert({ text: message, type: "success" }))
          toggle1() // HIDE CONFIRMATION MODAL
          toggle() // SHOW OTP MODAL
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleEnableJobApplication = () => {
    dispatch(enableJobApplication())
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          const { sessionId } = data
          setSessionId(sessionId)
          dispatch(showAlert({ text: message, type: "success" }))
          toggle1() // HIDE CONFIRMATION MODAL
          toggle() // SHOW OTP MODAL
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleOtpVerification = () => {
    const payload = {
      type: applicationType,
      sessionId,
      otp: convertArabicToNumber(otp),
    }
    dispatch(verifyActionOtp(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          const { sessionId } = data
          setSessionId(null)
          setOtp(null)
          dispatch(showAlert({ text: message, type: "success" }))
          fetchTimelineData()
          toggle()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content pg_tls">
        <Container fluid>
          <Row>
            <div className="g_between mb-3">
              <h4 className="card-title">{t("Time line Status")}</h4>
            </div>
          </Row>

          {loading ? (
            <Spinners />
          ) : (
            <Card className="theme_card">
              <CardBody>
                <div className="">
                  <div className="timeline-container">
                    {timeLine?.map((statusObj, index) => (
                      <div key={statusObj.id} className="timeline-group">
                        <div
                          className={`timeline-line ${
                            timeLine.length === 1 ? "first_step" : ""
                          }`}
                        ></div>{" "}
                        {/* Timeline line */}
                        <div className="timeline-item">
                          <div className="timeline-step">{index + 1}</div>
                          <div className="timeline-content">
                            <span>{statusObj.status}</span>
                            <div className="timeline-timestamp ltr">
                              {statusObj.timestamp}
                            </div>
                          </div>
                        </div>
                        {index < timeLine.length - 1 && (
                          <div className="timeline-separator" />
                        )}
                      </div>
                    ))}
                  </div>

                  {enabled_withdrawn_action && (
                    <div>
                      <Button
                        color="danger"
                        className="d-block mx-auto px-4 py-2 fs-4 mt-4"
                        onClick={() => {
                          setApplicationType("application_withdrawn")
                          toggle1()
                          // handleWithdrawnJobApplication()
                        }}
                      >
                        {t("Withdraw Application")}
                      </Button>
                    </div>
                  )}

                  {enabled_application_action && (
                    <div>
                      <Button
                        color="success"
                        className="d-block mx-auto px-4 py-2 fs-4 mt-4"
                        onClick={() => {
                          setApplicationType("application_enable")
                          // handleEnableJobApplication()
                          toggle1()
                        }}
                      >
                        {t("Reactive Application")}
                      </Button>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
      <Modal
        isOpen={modal1}
        toggle={toggle1}
        centered
        size="md"
        className="time_modal_withdrawn"
        backdrop="static"
      >
        <ModalHeader toggle={toggle1} style={{ fontSize: 16 }}>
          {applicationType === "application_withdrawn"
            ? t("Are you sure you want to withdraw your application?")
            : t("Are you sure you want to reactivate your application?")}
        </ModalHeader>
        <ModalBody>
          {/* APPLICATION WITHDRAWN */}
          {applicationType === "application_withdrawn" &&
            timeLine.some(item => item.status === "Application Submitted") && (
              <h5 className="">
                {t("You will not the able to proceed further.")}
              </h5>
            )}
          {/* {applicationType === "application_withdrawn" &&
            timeLine.some(item => item.status === "Interview Scheduled") && (
              <h5 className="">
                {t(
                  "You will not be eligible to attend the interview if you withdraw."
                )}
              </h5>
            )} */}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle1}>
            {t("No")}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              applicationType === "application_withdrawn"
                ? handleWithdrawnJobApplication()
                : handleEnableJobApplication()
            }}
            disabled={isLoading}
          >
            {t("Yes")}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modal} toggle={toggle} centered backdrop="static">
        <ModalHeader toggle={toggle}>{t("Verify OTP")}</ModalHeader>
        <ModalBody>
          <div className="otp_section">
            <InputOtp
              value={otp}
              onChange={e => setOtp(e.value)}
              length={6}
              pt={{ root: { placeholder: "------" } }}
              mask
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            {t("Cancel")}
          </Button>
          <Button
            color="primary"
            onClick={handleOtpVerification}
            disabled={otp?.length !== 6 || isLoading}
          >
            {t("Verify")}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default Timeline
